module.exports = __webpack_public_path__ + "images/Joshua_Stafford.jpg?v=175ddc7d93363aa0bd03b32c830cf1bd";